module.exports = __webpack_public_path__ + "static/media/moto_4.7f7ac8b3.png";